const ACCESS_TOKEN_KEY = "access_token";
const REFRESH_TOKEN_KEY = "refresh_token";

function readStore(key: string): string | null {
  try {
    return localStorage.getItem(key);
  } catch {
    return null;
  }
}

function writeStore(key: string, value: string) {
  try {
    localStorage.setItem(key, value);
  } catch {
    // Private mode on iOS can block storage; callers still have in-memory session.
  }
}

function removeStore(key: string) {
  try {
    localStorage.removeItem(key);
  } catch {
    // ignore
  }
}

export function getAccessToken(): string | null {
  return readStore(ACCESS_TOKEN_KEY);
}

export function getRefreshToken(): string | null {
  return readStore(REFRESH_TOKEN_KEY);
}

export function setAuthTokens(accessToken: string, refreshToken?: string) {
  writeStore(ACCESS_TOKEN_KEY, accessToken);
  if (refreshToken) {
    writeStore(REFRESH_TOKEN_KEY, refreshToken);
  }
}

export function clearAuthTokens() {
  removeStore(ACCESS_TOKEN_KEY);
  removeStore(REFRESH_TOKEN_KEY);
}

export function hasAuthCredentials(): boolean {
  return Boolean(getAccessToken() || getRefreshToken());
}
